import { render } from "./odn-modal-privacy.vue?vue&type=template&id=f59ace20"
import script from "./odn-modal-privacy.vue?vue&type=script&lang=js"
export * from "./odn-modal-privacy.vue?vue&type=script&lang=js"

import "./odn-modal-privacy.vue?vue&type=style&index=0&id=f59ace20&lang=scss"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__